export type CompanyFilterMode = 'include' | 'exclude';

export const resolveCompanyFilterMode = (
  currentMode: CompanyFilterMode,
  includeCount: number,
  excludeCount: number,
): CompanyFilterMode => {
  if (includeCount > 0 && excludeCount === 0) {
    return 'include';
  }

  if (excludeCount > 0 && includeCount === 0) {
    return 'exclude';
  }

  return currentMode;
};
